<div class="jumbotron animated fadeIn fast">
  <div class="container-fluid">
    <div class="container">
      <div class="row row-margin text-center">
        <h3 class="title">Carga de Solicitud</h3>
        <div class="space-bar center-block"></div>
      </div>
      <div class="row row-margin text-center">
        <img src="assets/images/pages/create-success.png" alt="Carga exitosa" />
      </div>
      <div class="row row-margin text-center">
        <p>
          La solicitud fue cargada <b class="primary">exitosamente</b>, a
          continuación se enviará al
          <b class="primary">Supervisor para que esta sea validada</b>.
        </p>
      </div>
      <div class="row text-center">
        <div class="col-md-6 col-table left">
          <div class="row text-left first">
            <div class="col-md-6">
              <span><b>Ruc Empresa</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _request.request.ruc }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Nombre / Razón social</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _request.request.companyName }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Monto total</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _request.request.amount | currency:'':'' | customCurrency: _request.request.currency }}</span>
            </div>
          </div>
          <div class="row text-left last">
            <div class="col-md-6">
              <span><b>Moneda</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _request.request.currency }}</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-table">
          <div class="row text-left first">
            <div class="col-md-6">
              <span><b>Tipo de solicitud</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _request.request.type.name }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Cantidad de registros</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _request.request.totalRecords | number }}</span>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-md-6">
              <span><b>Fecha de carga</b></span>
            </div>
            <div class="col-md-6">
              <span>{{ _request.request.date | date:'dd/MM/yyyy' }}</span>
            </div>
          </div>
          <div class="row text-left last">
            <div class="col-md-6">
              <span><b>Estado</b></span>
            </div>
            <div class="col-md-6">
              <span>Creada</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-margin text-center">
        <button
          class="button-continue center-block"
          (click)="newRequest()"
        >
          Ir a Carga de Solicitud
        </button>
        <div class="mt-15">
            <a
              (click)="_request.reset()"
              [routerLink]="_auth.user.getHomeUrl()"
              href=""
            >
              Ir a home ></a
            >
        </div>
      </div>
    </div>
  </div>
</div>
